import { render, staticRenderFns } from "./DashboardNotiList.vue?vue&type=template&id=706e4661&"
import script from "./DashboardNotiList.js?vue&type=script&lang=js&"
export * from "./DashboardNotiList.js?vue&type=script&lang=js&"
import style0 from "./DashboardNotiList.vue?vue&type=style&index=0&id=706e4661&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VTimeline,VTimelineItem})
